/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  app.ClosePopupMixin = {

    /**
     * Обработчик клика на body
     * @param e
     */
    bodyClick: function (e) {
      if (!$(e.target).hasClass('prevent-close-popup')) {
        this.hidePopup();
        this.arrowSelectDown();
      }
    }
  };
})(jQuery);

}.call(window));